import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useSubjectOutcomesUIContext } from "../SubjectOutcomesUIContext";

const prepareFilter = (queryParams, values) => {
  const { outcome, explanation } = values;
  const subjectId = queryParams.filter.subjectId;
  const newQueryParams = { ...queryParams };
  const filter = { subjectId, outcome, explanation };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function SubjectOutcomesFilter() {
  // SubjectOutcomes UI Context
  const subjectOutcomesUIContext = useSubjectOutcomesUIContext();
  const subjectOutcomesUIProps = useMemo(() => {
    return {
      setQueryParams: subjectOutcomesUIContext.setQueryParams,
      queryParams: subjectOutcomesUIContext.queryParams,
    };
  }, [subjectOutcomesUIContext]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(subjectOutcomesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, subjectOutcomesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      subjectOutcomesUIProps.setQueryParams(newQueryParams);
    }
  };
  
  return (
    <Formik
      initialValues={{
        outcome: "",
        explanation: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Kazanım"
                onBlur={handleBlur}
                value={values.outcome}
                onChange={(e) => {
                  setFieldValue("outcome", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kazanım</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="definition"
                placeholder="Açıklaması"
                onBlur={handleBlur}
                value={values.explanation}
                onChange={(e) => {
                  setFieldValue("explanation", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Açıklaması</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}